import { Button, Col, Form, Input, message, Row } from 'antd';
import { toLower, trim } from 'lodash';
import React, { useEffect } from 'react';
import { DeleteButton } from '../../../../../../assets/svg';
import { formValidatorRules } from '../../../../../../common/utils';

const CommonRegisterOptionUi = ({ isDisabled, form, optionsInputRef }) => {
  const { required, characterWithoutWhiteSpace } = formValidatorRules;

  useEffect(() => {
    if (optionsInputRef?.current) {
      optionsInputRef?.current?.focus();
    }
  }, []);

  return (
    <>
      <Form.List name="options">
        {(fields, { add, remove }) => {
          return (
            <Row gutter={[15, 15]} className="width-percent-100">
              {fields.map((field, index) => (
                <Col span={24} key={field?.key}>
                  <Row gutter={[30]}>
                    <Col flex="auto">
                      <Form.Item
                        {...field}
                        label="Value"
                        name={[field.name, 'option']}
                        fieldKey={[field?.fieldKey, 'option']}
                        validateTrigger={['onChange', 'onClick']}
                        rules={[
                          required,
                          characterWithoutWhiteSpace,
                          {
                            max: 250,
                            message: 'Maximum 250 characters are allowed',
                          },
                          ({ getFieldValue }) => ({
                            validator(_, value) {
                              const currentValue = toLower(trim(value || ''));
                              if (!currentValue) return Promise?.resolve();
                              const allOptions = getFieldValue('options') || [];
                              const matches = allOptions?.filter(
                                (item) =>
                                  toLower(trim(item?.option || '')) ===
                                  currentValue,
                              );
                              if (matches?.length > 1) {
                                return Promise?.reject(
                                  new Error('should be an unique option'),
                                );
                              }
                              return Promise?.resolve();
                            },
                          }),
                        ]}
                      >
                        <Input
                          ref={index === 0 ? optionsInputRef : null}
                          autoFocus
                          placeholder="Enter Value"
                          disabled={isDisabled}
                          onChange={(e) => {
                            const newValue = e?.target?.value;
                            form?.setFieldValue(
                              ['options', field?.name, 'option'],
                              newValue,
                            );

                            const allOptions =
                              form?.getFieldValue('options') || [];
                            const allFields = allOptions?.map((_, idx) => [
                              'options',
                              idx,
                              'option',
                            ]);
                            form?.validateFields(allFields);
                          }}
                        />
                      </Form.Item>
                    </Col>
                    <Col className="d-flex align-center">
                      {fields?.length > 2 && (
                        <Form.Item className="mb-0">
                          <DeleteButton
                            className="pointer"
                            onClick={async () => {
                              if (!isDisabled && fields?.length > 2) {
                                remove(field?.name);
                                setTimeout(() => {
                                  const options =
                                    form?.getFieldValue('options') || [];
                                  const allFields = options?.map(
                                    (_, fieldIndex) => [
                                      'options',
                                      fieldIndex,
                                      'option',
                                    ],
                                  );
                                  form?.validateFields(allFields);
                                }, 0);
                              }
                            }}
                          />
                        </Form.Item>
                      )}
                    </Col>
                  </Row>
                </Col>
              ))}
              <Row>
                <Col className="mb-15">
                  <Button
                    className="grey-button"
                    shape="round"
                    htmlType="submit"
                    disabled={isDisabled}
                    onClick={(e) => {
                      if (
                        !trim(
                          form?.getFieldValue([
                            'options',
                            fields?.length - 1,
                            'option',
                          ]),
                        )
                      ) {
                        e?.preventDefault();
                        return;
                      }
                      if (fields?.length >= 20) {
                        e?.preventDefault();
                        message.destroy();
                        message.error('You can only add up to 20 options.');
                        return;
                      }
                      add();
                    }}
                    block
                  >
                    Add Option
                  </Button>
                </Col>
              </Row>
            </Row>
          );
        }}
      </Form.List>
    </>
  );
};

export default CommonRegisterOptionUi;
